import {
  checkDefined,
  CommonPERequest,
  MultiplePersonalizationEngineRequest,
  RequestParam,
  UserData
} from '@com-delta-idp/mnx-skymiles-shared';
import { LoyaltyBalance } from '../models/api/tracker-details.interfaces';
import { StatusTrackerResponse } from '../models/api/tracker.interfaces';
import { TYPE } from '../models/overview.constants';
import { getThreshold } from './tracker/earnometer.utils';

export const getMultiplePERequest = (
  params: CommonPERequest,
  statusTracker: StatusTrackerResponse | undefined
): MultiplePersonalizationEngineRequest => {
  const requestparam: RequestParam = {
    campaignId: [
      checkDefined(params.micromomentCampaignId),
      checkDefined(params.bannerCampaignId),
      checkDefined(params.offerCampaignId)
    ],
    format: checkDefined(params.format)
  };

  const userdata: UserData = {
    membershipLevel: checkDefined(params.membershipLevel),
    amexCardMember: params.amexCardMember,
    usResident: statusTracker?.countryCode == 'US' ? 'Y' : 'N',
    ageRestrict: checkDefined(params.ageRestrict),
    birthDay: params.birthDay,
    sevenDaysBeforeBirthday: params.sevenDaysBeforeBirthday,
    sevenDaysAfterBirthday: params.sevenDaysAfterBirthday,
    mqdValue:
      getThreshold(statusTracker?.currentLoyaltyMemberMedallionStatus, TYPE.MQD)
        ?.balanceAmt || 0,
    internationalUser: statusTracker?.countryCode == 'US' ? false : true,
    skyMilesAnniversary: params.skyMilesAnniversary,
    mqdPercent: getDollarPercent(statusTracker),
    availableMiles: getAvailableMiles(statusTracker),
    profileSetUp: params.profileSetUp,
    newJoiner: params.newJoiner,
    rollover: getRolloverMiles(statusTracker),
    currentDate: getCurrentDate(params.currentDate),
    presentDate: params.currentDate,
    downgradeTier: getDowngradedTierLevelIndicator(statusTracker),
    skyclub: params.skyclub
  };

  return { requestparam, userdata };
};

const getCurrentDate = (currentDate: string): string => {
  return Number(localStorage.getItem('earning-simpler')) < 2 ? currentDate : '';
};

const getDollarPercent = (
  tracker: StatusTrackerResponse | undefined
): number => {
  return Math.round(
    Number(
      getThreshold(
        tracker?.currentLoyaltyMemberMedallionStatus,
        TYPE.MQD
      )?.percentCompleteNum?.replace('%', '') || 0
    )
  );
};

const getAvailableMiles = (
  tracker: StatusTrackerResponse | undefined
): number => {
  return (
    tracker?.loyaltyMemberProgramBalance?.loyaltyBalances.find(
      (miles) => miles.balanceTypeCode === TYPE.AVAIL
    )?.balanceAmt || 0
  );
};

const getRolloverMiles = (
  tracker: StatusTrackerResponse | undefined
): string => {
  const year = new Date().getFullYear().toString();
  const loyaltyBalances = tracker?.loyaltyMemberAnnualBalances?.find(
    (miles) => miles.balanceStartLocalDate === year
  )?.loyaltyBalances;

  const rollover = loyaltyBalances?.find(
    (balance) => balance.balanceTypeCode === TYPE.ROLL
  );

  return rollover ? getRolloverDesc(rollover) : '';
};

const getRolloverDesc = (rollover: LoyaltyBalance): string => {
  return (rollover.balanceTypeDesc === TYPE.ROLLOVER_MQM &&
    rollover.balanceAmt !== 0) ||
    rollover.balanceTypeDesc !== TYPE.ROLLOVER_MQM
    ? rollover.balanceTypeDesc
    : '';
};

const getDowngradedTierLevelIndicator = (
  tracker: StatusTrackerResponse | undefined
): boolean => {
  return (
    tracker?.loyaltyMemberTierLevels?.find(
      (tierLevel) =>
        tierLevel.tierStatusDesc === TYPE.CURRENT &&
        tierLevel.tierLevelClassificatinCode === TYPE.TIER_CODE
    )?.tierNextPeriodDowngrade || false
  );
};
